import axios from './axiosInstances/axiosInstance';

export const removeProductFromBasket = (basketGuid, basketProductId) => {
  return axios.delete(`/baskets/${basketGuid}/products/${basketProductId}`);
};
